var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34 34",
    style: {
      enableBackground: "new 0 0 34 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.6,14.6c-0.2-0.3-0.5-0.5-0.9-0.5h-6.8V2.4c0-0.4-0.3-0.8-0.7-0.9c-0.4-0.1-0.8,0-1.1,0.4L6.5,18.4 c-0.2,0.3-0.2,0.7-0.1,1c0.2,0.3,0.5,0.5,0.9,0.5h6.8v11.7c0,0.4,0.3,0.8,0.7,0.9c0.1,0,0.2,0,0.3,0c0.3,0,0.6-0.2,0.8-0.4 l11.7-16.5C27.7,15.3,27.7,14.9,27.6,14.6L27.6,14.6z M16,28.5v-9.6c0-0.5-0.4-1-1-1H9.2L18,5.5v9.6c0,0.5,0.4,1,1,1h5.9L16,28.5z  M16,28.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.5183377f8229d7b2bdd0f2cb27c6d4a2.svg";
export { ForwardRef as ReactComponent };